import * as React from "react";
import clockIcon from '../assets/images/clock.svg';
import { useState, useEffect } from "react";
import { DataGrid, GridOverlay } from "@mui/x-data-grid";
import CircularProgress from "@mui/material/CircularProgress";
import { getActionType } from "../services/commonService";
import { formatDateTime, formatDateTimeNotEffectTimeZone } from "../utils/validate";
import { HistoryDespCard } from "../pages/historyTab/HistoryDespCard";
import { EmailPreviewModal } from "./EmailPreviewModal ";

// ── DataGrid columns matching your actual data shape ──────
const detailColumns = [
    { field: "internalEventId", headerName: "Internal ID", width: 100 },
    { field: "whiseEventIds", headerName: "Whise Event ID", width: 120 },
    { field: "StartDateTime", headerName: "Start Date Time", flex: 1, width: 300, valueFormatter: (value) => formatDateTimeNotEffectTimeZone(value) },
    { field: "EndDateTime", headerName: "End Date Time", flex: 1, width: 250, valueFormatter: (value) => formatDateTimeNotEffectTimeZone(value) }, 
    { field: "AgentId", headerName: "Agent Id", width: 110 },
    { field: "AgentName", headerName: "Agent Name", flex: 1 },
    { field: "ContactId", headerName: "Contact Id", flex: 1 },
    { field: "ContactName", headerName: "Contact Name", flex: 1 },
];

const CustomLoadingOverlay = () => (
    <GridOverlay><CircularProgress size={28} /></GridOverlay>
);

export const ActionLogItem = ({ actionLogsList, isLoading, estateId }) => {

    const [actionTypeList, setActionTypeList] = useState([]);

    // Per-row expand state: { [item.id]: { expanded } }
    const [rowStates, setRowStates] = useState({});

    const [showEmailPreview, setShowEmailPreview] = useState(false);
    const [emailHtml, setEmailHtml] = useState("");

    // Simple toggle — no API call needed, data is already in metadata
    const handlerViewDetailShow = (itemId) => {
        setRowStates(prev => ({
            ...prev,
            [itemId]: { expanded: !prev[itemId]?.expanded }
        }));
    };

    useEffect(() => {
        const getActionLogs = async () => {
            const actionLogs = await getActionType();
            setActionTypeList(actionLogs.data);
        };
        getActionLogs();
    }, []);

    const handlePreviewClick = (emailBody) => {
        setEmailHtml(emailBody); // the string you pasted above
        setShowEmailPreview(true);
    };
    console.log(actionLogsList);
    return (
        <>
            <div>
                {isLoading ? (
                    <p className="d-flex justify-content-center align-items-center" style={{ height: "75vh" }}>Loading...</p>
                ) : actionLogsList.length === 0 ? (
                    <p className="text-center pt-5">No records found !</p>
                ) : (
                    actionLogsList.map((item, index) => {
                        const deSerilize = JSON.parse(item.metadata);
                        //console.log(deSerilize.EmailBody);
                        // Add `id` field — DataGrid requires it

                        let detailRows;
                        if (item.actionId == 3) {
                            //console.log(deSerilize?.eventDetail);
                            detailRows = (deSerilize?.eventDetail ?? []).map((row, i) => ({
                                ...row,
                                id: row?.internalEventId ?? row?.CalendarActionId ?? i,
                                ContactId: row?.ContactIds[0] ?? "",
                                ContactName: row?.ContactName ?? "Dummy contact",
                                AgentId: row?.agentDetail[0]?.agentDetail?.id,
                                AgentName: `${row?.agentDetail[0]?.agentDetail?.firstName ?? ""} ${row?.agentDetail[0]?.agentDetail?.name ?? ""}`.trim(),
                            }));
                        } else if (item.actionId == 5) {

                            let gridArrObj = {
                                id: index,
                                internalEventId: deSerilize.eventDetail?.id,
                                whiseEventIds: deSerilize.eventDetail?.newWhiseEventId,
                                StartDateTime: deSerilize.eventDetail?.eventStartDateTime,
                                EndDateTime: deSerilize?.eventDetail?.eventEndDateTime,
                                ContactId: deSerilize.eventDetail?.contacts[0]?.contactId,
                                ContactName: `${deSerilize.eventDetail?.contacts[0]?.firstName} ${deSerilize.eventDetail?.contacts[0]?.name}`,
                                AgentId: deSerilize.eventDetail?.agentDetail?.id,
                                AgentName: `${deSerilize.eventDetail?.agentDetail?.firstName ?? ""} ${deSerilize.eventDetail?.agentDetail?.name ?? ""}`.trim(),
                            }

                            detailRows = [gridArrObj];
                        } else if (item.actionId == 6 || item.actionId == 7 || item.actionId == 8) {

                            let gridArrObj = {
                                id: index,
                                internalEventId: deSerilize.eventDetail?.eventDetail?.Id,
                                whiseEventIds: deSerilize.eventDetail?.eventDetail?.WhiseEventId,
                                StartDateTime: deSerilize.eventDetail?.eventDetail?.StartDateTime,
                                EndDateTime: deSerilize?.eventDetail?.eventDetail?.EndDateTime,
                                ContactId: deSerilize.eventDetail?.contactDetail?.Id,
                                ContactName: `${deSerilize.eventDetail?.contactDetail?.FirstName} ${deSerilize.eventDetail?.contactDetail?.Name}`.trim(),
                                AgentId: deSerilize.eventDetail?.agentDetail?.ExternalId,
                                AgentName: `${deSerilize.eventDetail?.agentDetail?.FirstName ?? ""} ${deSerilize.eventDetail?.agentDetail?.Name ?? ""}`.trim(),
                            }

                            detailRows = [gridArrObj];
                        }

                        //console.log(detailRows);

                        const expanded = rowStates[item.id]?.expanded ?? false;
                        
                        return (
                            <div key={item.id} className={`action-log-container p-3 mb-3 ${item.actionStatus ? "" : "bg-error"}`}>
                                <div>

                                    {/*<div className="d-flex justify-content-between align-items-center">*/}
                                    {/*    <h6 className="mb-2 d-flex">*/}
                                    {/*        <img src={clockIcon} className="me-1" width="20" alt="clock icon" />*/}
                                    {/*        {formatDateTime(item.creationDateTime)}*/}
                                    {/*    </h6>*/}
                                    {/*    <div className={`${item.parentLogId ? "d-flex align-items-center" : "d-none"}`}>*/}
                                    {/*        <h6 className="mb-0 me-3">Source: {item.parentLogId}</h6>*/}
                                    {/*        {*/}
                                    {/*            item.actionStatus ?*/}
                                    {/*                <h6 className="my-0">Origin: {item.origin}</h6>*/}
                                    {/*                :*/}
                                    {/*                <h6 className="my-0">Origin: {actionTypeList.find(a => a.id === item.actionId)?.actionName}</h6>*/}
                                    {/*        }*/}
                                    {/*    </div>*/}
                                    {/*</div>*/}
                                    <div className="d-flex justify-content-between align-items-center">
                                        <h6 className="mb-2 d-flex">
                                            <img src={clockIcon} className="me-1" width="20" alt="clock icon" />
                                            {formatDateTime(item.creationDateTime)}
                                        </h6>
                                        <div className="d-flex align-items-center">
                                            {
                                                item.parentLogId ?
                                                    <h6 className="mb-0 me-3">Source: {item.parentLogId}</h6>
                                                    :
                                                    <h6 className="mb-0 me-3">Internal Log Id: {item.id}</h6>
                                            }
                                            {
                                                item.parentLogId &&
                                                (
                                                    item.actionStatus ?
                                                        <h6 className="my-0">Origin: {item.origin}</h6>
                                                        :
                                                        <h6 className="my-0">Origin: {actionTypeList.find(a => a.id === item.actionId)?.actionName}</h6>
                                                )
                                            }
                                        </div>
                                    </div>

                                    <div className="d-flex justify-content-between align-items-center mb-3">
                                        {
                                            item.actionStatus ?
                                                <>
                                                    <p className="mb-0 log-label action-log-btn-padd">
                                                       {actionTypeList.find(a => a.id === item.actionId)?.actionName}
                                                   </p>
                                                   <p className="mb-0 site-btn-red action-log-btn-padd">
                                                       Sync with Whise CRM: {item.syncWithWhise == null ? "N/A" : item.syncWithWhise ? "Success" : "Fail"}
                                                   </p>
                                        </>
                                                :
                                                <p className="mb-0 site-btn-red action-log-btn-padd">
                                                    Error Log
                                                </p>

                                        }
                                       
                                        
                                    </div>

                                    <div className="d-flex justify-content-between align-items-center">
                                        <HistoryDespCard item={item} />
                                        <div className={`${item.actionStatus ? "" : "d-none"}`}>
                                            {
                                                item.actionId == 9 || item.actionId == 12 ?
                                                    <button className="mb-0 action-log-btn-padd site-btn"
                                                        onClick={() => handlePreviewClick(deSerilize)}>
                                                        Preview Email
                                                    </button>
                                                    :
                                                    <button
                                                        className={`${item.actionId == 4 || item.actionId == 1 || item.actionId == 2 ? "d-none" : "mb-0 action-log-btn-padd site-btn"}`}
                                                        onClick={() => handlerViewDetailShow(item.id)}
                                                    >
                                                        {expanded ? "Less Details" : "View Details"}
                                                    </button>
                                            }
                                        </div>
                                    </div>
                                </div>

                                {/* DataGrid — renders when expanded */}
                                {expanded && (
                                    <div className="mt-3">
                                        <DataGrid
                                            rows={detailRows}
                                            columns={detailColumns}
                                            pageSizeOptions={[5, 10, 25]}
                                            initialState={{ pagination: { paginationModel: { pageSize: 5 } } }}
                                            disableRowSelectionOnClick
                                            getRowClassName={({ indexRelativeToCurrentPage: i }) =>
                                                i % 2 === 0 ? "even-row-waiting-grid" : "odd-row-waiting-grid"
                                            }
                                            disableColumnMenu
                                            slots={{ loadingOverlay: CustomLoadingOverlay }}
                                            autoHeight
                                            sx={{ width: "100%" }}
                                        />
                                    </div>
                                )}
                            </div>
                        );
                    })
                )}
            </div>

            <EmailPreviewModal
                show={showEmailPreview}
                close={() => setShowEmailPreview(false)}
                htmlContent={emailHtml}
            />

        </>
    );
};

